"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withGiraffe = exports.routePathToSlug = exports.loadStaticProps = exports.loadStaticPaths = exports.loadServerSideDocumentProps = exports.buildTypo3PreviewHeaders = exports.buildTypo3Headers = void 0;
var _loglevel = _interopRequireDefault(require("loglevel"));
_loglevel.default.setDefaultLevel(_loglevel.default.levels.DEBUG);
const loadStaticPaths = async ({
  locales,
  defaultLocale
}) => {
  const apiUrl = process.env.TYPO3_BASE_URL;
  if (!apiUrl) {
    throw new Error('Missing TYPO3_BASE_URL environment variable');
  }
  const startTime = Date.now();
  const fetchUrl = apiUrl + '/?type=834';
  const response = await fetch(fetchUrl, {
    headers: buildTypo3Headers()
  });
  if (!response.ok) {
    const data = await response.json();
    if (data.errors) {
      const flatErrors = data.errors.map(e => e.message).join(', ');
      _loglevel.default.error('error fetching from headless API with url', fetchUrl, ':', flatErrors);
      throw new Error('Headless API responded with error: ' + flatErrors);
    }
  }
  const data = await response.json();
  const endTime = Date.now();
  _loglevel.default.debug('fetched documents from headless API, took', `${endTime - startTime}ms`);
  const paths = {};
  const traverseNavigation = documents => {
    for (const document of documents) {
      if (document.link === '/') {
        paths[document.link] = {
          params: {
            slug: ['']
          }
        };
      }
      paths[document.link] = {
        params: {
          slug: routePathToSlug(document.link)
        }
      };
      if (document.children && document.children.length > 0) {
        traverseNavigation(document.children);
      }
    }
  };
  traverseNavigation(data.navigation);
  return Object.values(paths);
};
exports.loadStaticPaths = loadStaticPaths;
const loadStaticProps = async ({
  params,
  locale,
  defaultLocale,
  draftMode
}) => {
  const apiUrl = process.env.TYPO3_BASE_URL;
  if (!apiUrl) {
    throw new Error('Missing TYPO3_BASE_URL environment variable');
  }
  if (!params) {
    return undefined;
  }
  const localePrefix = locale && locale !== defaultLocale ? locale + '/' : '';
  const path = '/' + localePrefix + (params !== null && params !== void 0 && params.slug && Array.isArray(params.slug) ? params.slug.join('/') : '');
  const startTime = Date.now();
  const fetchUrl = apiUrl + path;
  const response = await fetch(fetchUrl, {
    headers: buildTypo3Headers()
  });
  if (!response.ok) {
    if (response.status === 404) {
      _loglevel.default.debug('Headless API returned 404 for path', path);
      return undefined;
    }
    const data = await response.json();
    if (data.errors) {
      const flatErrors = data.errors.map(e => e.message).join(', ');
      _loglevel.default.error('error fetching from headless API with url', fetchUrl, ':', flatErrors);
      throw new Error('Headless API responded with error: ' + flatErrors);
    }
  }
  const data = await response.json();
  const endTime = Date.now();
  _loglevel.default.debug('fetched data from headless API for path', path, ', took', `${endTime - startTime}ms`);
  return data;
};
exports.loadStaticProps = loadStaticProps;
const loadServerSideDocumentProps = async ({
  query,
  req
}) => {
  const apiUrl = process.env.TYPO3_BASE_URL;
  if (!apiUrl) {
    throw new Error('Missing TYPO3_BASE_URL environment variable');
  }
  const {
    slug
  } = query;
  const path = '/' + (slug && Array.isArray(slug) ? slug.join('/') : '');
  if (!path) {
    throw new Error('Missing path query parameter');
  }
  const startTime = Date.now();
  const fetchUrl = apiUrl + path;
  const response = await fetch(fetchUrl, {
    headers: buildTypo3PreviewHeaders(req)
  });
  if (!response.ok) {
    if (response.status === 404) {
      _loglevel.default.debug('Headless API returned 404 for path', path);
      return undefined;
    }
    const data = await response.json();
    if (data.errors) {
      const flatErrors = data.errors.map(e => e.message).join(', ');
      _loglevel.default.error('error fetching from headless API with url', fetchUrl, ':', flatErrors);
      return undefined;
    }
  }
  const data = await response.json();
  const endTime = Date.now();
  _loglevel.default.debug('fetched data from content API for path', path, ', took', `${endTime - startTime}ms`);
  return data;
};
exports.loadServerSideDocumentProps = loadServerSideDocumentProps;
const routePathToSlug = routePath => {
  if (routePath.startsWith('/')) {
    routePath = routePath.substring(1);
  }
  if (routePath.endsWith('.html')) {
    routePath = routePath.substring(0, routePath.length - 5);
  }
  return routePath.split('/');
};
exports.routePathToSlug = routePathToSlug;
const buildTypo3Headers = () => {
  const headers = {};
  if (process.env.PUBLIC_BASE_URL) {
    applyProxyHeaders(headers, process.env.PUBLIC_BASE_URL);
  }
  return headers;
};
exports.buildTypo3Headers = buildTypo3Headers;
const buildTypo3PreviewHeaders = req => {
  var _req$headers$cookie;
  const headers = {
    Cookie: (_req$headers$cookie = req.headers.cookie) !== null && _req$headers$cookie !== void 0 ? _req$headers$cookie : ''
  };
  if (process.env.PUBLIC_BASE_URL) {
    _loglevel.default.debug(`PUBLIC_BASE_URL is set (${process.env.PUBLIC_BASE_URL}), using it for X-Forwarded-* headers`);
    applyProxyHeaders(headers, process.env.PUBLIC_BASE_URL);
  } else {
    _loglevel.default.debug('PUBLIC_BASE_URL is not set, using X-Forwarded-* headers from request');
    if (req.headers.host) {
      const [host, port] = req.headers.host.split(':');
      headers['X-Forwarded-Host'] = host;
      if (port) {
        headers['X-Forwarded-Port'] = port;
      } else {
        headers['X-Forwarded-Port'] = req.headers['x-forwarded-proto'] === 'https' ? '443' : '80';
        headers['X-Forwarded-Proto'] = typeof req.headers['x-forwarded-proto'] === 'string' ? req.headers['x-forwarded-proto'] : 'http';
      }
    }
  }
  _loglevel.default.debug('headers for preview request:', headers);
  return headers;
};
exports.buildTypo3PreviewHeaders = buildTypo3PreviewHeaders;
const applyProxyHeaders = (headers, baseUrl) => {
  const publicBaseUrl = new URL(baseUrl);
  headers['X-Forwarded-Host'] = publicBaseUrl.hostname;
  headers['Host'] = publicBaseUrl.hostname;
  if (publicBaseUrl.port) {
    headers['X-Forwarded-Port'] = publicBaseUrl.port;
  } else {
    headers['X-Forwarded-Port'] = publicBaseUrl.protocol === 'https:' ? '443' : '80';
  }
  headers['X-Forwarded-Proto'] = publicBaseUrl.protocol === 'https:' ? 'https' : 'http';
};
const withGiraffe = nextConfig => {
  return {
    ...nextConfig,
    rewrites: async () => {
      var _nextConfig$rewrites;
      const typo3Rewrites = [{
        source: '/typo3/:path*',
        destination: process.env.TYPO3_BASE_URL + '/typo3/:path*'
      }, {
        source: '/typo3conf/:path*',
        destination: process.env.TYPO3_BASE_URL + '/typo3conf/:path*'
      }, {
        source: '/typo3temp/:path*',
        destination: process.env.TYPO3_BASE_URL + '/typo3temp/:path*'
      }, {
        source: '/_assets/:path*',
        destination: process.env.TYPO3_BASE_URL + '/_assets/:path*'
      }];
      const rewrites = await ((_nextConfig$rewrites = nextConfig.rewrites) === null || _nextConfig$rewrites === void 0 ? void 0 : _nextConfig$rewrites.call(nextConfig));
      if (!rewrites) {
        return typo3Rewrites;
      }
      if (Array.isArray(rewrites)) {
        return rewrites.concat(typo3Rewrites);
      }
      rewrites.afterFiles = rewrites.afterFiles.concat(typo3Rewrites);
      return rewrites;
    }
  };
};
exports.withGiraffe = withGiraffe;